module.exports = __webpack_public_path__ + "img/collective-debitors.4b7b3c74.svg";